import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { GameConstants } from "../../constant/GameConstants";
/**
 * RealityCheckDetailsResponseData.ts
 */
export class RealityCheckDetailsResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyValues();
        }
    }
    solidifyValues() {
        this.realityCheckInterval = this.data.getNumber(GameConstants.PROPERTY_REALITY_CHECK_INTERVAL);
        this.totalSessionTime = this.data.getNumber(GameConstants.PROPERTY_TOTAL_SESSION_TIME);
        this.nextRealityCheck = this.data.getNumber(GameConstants.PROPERTY_NEXT_REALITY_CHECK);
        this.timeCreated = this.getNow();
    }
    isEnabled() {
        return this.realityCheckInterval > 0;
    }
    hasExpired() {
        return this.nextRealityCheck <= 0;
    }
    getTimeToExpiry() {
        return this.totalSessionTime > 0 ? (this.realityCheckInterval - (this.totalSessionTime % this.realityCheckInterval)) : this.realityCheckInterval;
    }
    getRealityCheckInterval() {
        return this.realityCheckInterval;
    }
    getNextRealityCheck() {
        return this.nextRealityCheck;
    }
    getTotalSessionTime() {
        return this.totalSessionTime + (this.getNow() - this.timeCreated);
    }
    getNow() {
        return (new Date().getTime());
    }
}
//# sourceMappingURL=RealityCheckDetailsResponseData.js.map